<section class="testimonials" id="testimonials">
  <div class="testimonials__content">
    <h2 class="testimonials__headline">{{ 'TESTIMONIALS.TITLE' | translate }}</h2>
    <p class="testimonials__subtext">{{ 'TESTIMONIALS.SUBTITLE' | translate }}</p>
    <div class="testimonials__line"></div>

    <div class="testimonial testimonial--featured">
      <p [innerHTML]="'TESTIMONIALS.FEATURED.TEXT' | translate"></p>
      <div class="testimonial__author testimonial__author--centered">
        <div [innerHTML]="'TESTIMONIALS.FEATURED.AUTHOR' | translate"></div>
      </div>
    </div>
    
    <p class="trusted-by">{{ 'TESTIMONIALS.TRUSTED' | translate }}</p>

    <div class="testimonial-logos">
      <img src="dentsplysirona.webp" alt="Dentsply Sirona" width="150" height="50" loading="lazy" decoding="async" />
      <img src="rtl.webp" alt="RTL" width="120" height="50" loading="lazy" decoding="async" />
      <img src="deutschebahn.webp" alt="Deutsche Bahn" width="150" height="50" loading="lazy" decoding="async" />
      <img src="endresshauser.webp" alt="Endress Hauser" width="150" height="50" loading="lazy" decoding="async" />
    </div>
    

    <div class="testimonial" *ngFor="let item of ['TESTIMONIALS.LIST.0', 'TESTIMONIALS.LIST.1', 'TESTIMONIALS.LIST.2', 'TESTIMONIALS.LIST.3']">
      <p [innerHTML]="(item + '.TEXT') | translate"></p>
      <span [innerHTML]="(item + '.AUTHOR') | translate"></span>
    </div>
  </div>
</section>
